// extracted by mini-css-extract-plugin
export default {"container":"Words_container__HvOkm","title":"Words_title__8vw2J","subtitle":"Words_subtitle__ZNQhg"};